export const APP_ID = 'medibank-pp-web';
export const TENANT_ID = 'medibank-pp';

export const MASONRY = {
  ROOT_NODE_ID_HOME_PAGE: 'home$root',
  ROOT_NODE_APPOINTMENTS_LANDING_PAGE: 'appointmentsLanding$root',
  ROOT_NODE_APPOINTMENT_DETAILS_PAGE: 'appointmentDetails$web$root',
  ROOT_NODE_IN_PERSON_CONSULTATION_PAGE:
    'secondaryPages$inPersonConsultationWeb$root',
  ROOT_NODE_VIRTUAL_CONSULTATION_PAGE:
    'secondaryPages$virtualConsultationWeb$root',
  ROOT_NODE_LINKED_CENTRES_LANDING_PAGE: 'yourClinicsLanding$root',
};

export const QUERY_PARAM_MODAL_VALUE = {
  DELETE_ACCOUNT: 'delete-account',
  DELETE_ACCOUNT_DISCLAIMER: 'delete-account-disclaimer',
};

export enum QUERY_PARAM_KEYS {
  MODAL = 'modal',
  CANCEL_URL = 'cancelUrl',
}

export const ANALYTICS_DETAILS = {
  CANCEL: 'cancel',
  CONFIRM_DELETION: 'confirm deletion',
  ACKNOWLEDGE_DELETION: 'acknowledge deletion',
};

export const ANALYTICS_SCREEN_NAMES = {
  DELETION_CONFIRMATION: 'deletion confirmation',
  LOGIN_ERROR: 'login error',
};

export const AUTH0_ERROR_TYPES = {
  LOGIN_REQUIRED: 'login_required',
};

export const SUB_PRODUCT_AREA_NAMES = {
  SIGN_IN: 'sign in',
};

export const SECONDARY_CONTENT_MAX_WIDTH = '772px';

export const DAY_MONTH_YEAR_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
};
